import React from 'react';
import {useHistory} from 'react-router-dom';
import SettingsIcon from '@material-ui/icons/Settings';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import RadioIcon from '@material-ui/icons/Radio';
import {ROUTESLIST} from '@/static/urls';
import {useAuth0} from '@auth0/auth0-react';
import {Link} from 'react-router-dom';

const Sidebar = () => {
    const history = useHistory();
    const {logout} = useAuth0();

    const handleNavigate = (path) => {
        history.push(path);
    };

    const removeCameFrom = () => {
        localStorage.removeItem('requestedFrom')
    }
    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('isIdentityLogin');
        logout({
            logoutParams: {returnTo: window.location.origin},
        });
        // history.push(ROUTESLIST.HOME);
    };

    return (
        <div className="side-menu">
            <div className="side-menu-profile-img">
                <div className="profile-wrapper">
                    <img src="https://picsum.photos/150/150" alt="user profile"/>
                </div>
            </div>
            <ul className="side-menu-wrapper">
                <li
                    className="menu-items"
                    onClick={() => handleNavigate('/userdashboard/mysamples')}
                >
                    <i className="as-icon as-icon_sample-big"></i>
                    MY SAMPLES
                </li>
                <ul className="sub-menu-items">
                    <Link to={ROUTESLIST.DASHBOARD_SAMPLES} className="nav-sub__link">
                        <li className="sub-items">
                            <i className="as-icon as-icon_sample"></i>
                            <span>Samples</span>
                        </li>
                    </Link>
                    <Link to={ROUTESLIST.DASHBOARD_SYNC} className="nav-sub__link">
                        <li className="sub-items">
                            {/* <img src={TwitterIcon} className="sub-social-icons" /> */}
                            <RadioIcon className="sub-social-icons"/>
                            <span>Sync</span>
                        </li>
                    </Link>
                </ul>

                <Link to={ROUTESLIST.DASHBOARD_SETTINGS} className="nav-sub__link">
                    {' '}
                    <li className="menu-items">
                        <i className="as-icon as-icon_settings"></i>
                        ACCOUNT SETTINGS
                    </li>
                    <ul className="sub-menu-items">

                        <li
                            className="sub-items"
                        >
                            <Link
                                to={ROUTESLIST.DASHBOARD_SECURITY}
                                className="nav-sub__link"
                            >
                                <i className="as-icon as-icon_lock"></i>
                                <span>Security</span>
                            </Link>
                        </li>
                    </ul>
                </Link>
                <Link to={ROUTESLIST.SERVICES} className="nav-sub__link" onClick={removeCameFrom}>
                    <li className="menu-items">
                        {/* <img src={TwitterIcon} className="social-icons" /> */}
                        <SettingsIcon className="social-icons"/>
                        SERVICES
                    </li>
                </Link>
                <Link to={ROUTESLIST.BILLING_HISTORY} className="nav-sub__link">
                    <li className="menu-items">
                        <i className="as-icon as-icon_payment"></i>
                        TRANSACTIONS <span className="order-count">0</span>
                    </li>
                </Link>
                <li className="menu-items" onClick={handleLogout}>
                    {/* <img src={TwitterIcon} className="social-icons" /> */}
                    <ExitToAppIcon className="social-icons"/>
                    LOGOUT
                </li>
            </ul>
        </div>
    );
};

export default Sidebar;
